import { Button, Slide, Snackbar } from '@material-ui/core';
import { SnackbarProvider, useSnackbar } from 'notistack';
import React, { useEffect } from 'react';
import create, { UseStore } from 'zustand';
import shallow from 'zustand/shallow';

export type ToastApi = {
  message: string;
  open: boolean;
  setOpen(value: boolean, message?: string): void;
  onClose?: () => void;
  style?: any;
};

export function toastApi(onClose?: () => void): UseStore<ToastApi> {
  return create<ToastApi>((set) => ({
    onClose,
    message: '',
    open: false,
    setOpen: (open, message) => {
      set({ open, message });
      if (!open && onClose) {
        onClose();
      }
    },
  }));
}

interface ToastProps {
  api: UseStore<ToastApi>;
}

export function Toast(props: ToastProps) {
  const { api } = props;
  const [message, open, setOpen, style] = api(
    (s) => [s.message, s.open, s.setOpen, s.style],
    shallow
  );

  const onClose = () => {
    setOpen(false);
  };

  const show = open ? undefined : { display: 'none' };
  return (
    <Snackbar
      style={{ ...{ zIndex: 9999 }, ...show }}
      TransitionComponent={(props) => <Slide {...props} direction="up" />}
      action={
        <Button color="secondary" size="small" onClick={onClose}>
          ClOSE
        </Button>
      }
      open={open}
      message={
        <div
          style={{
            ...{ width: '500px', maxHeight: '80vh', overflowY: 'scroll' },
            ...style,
          }}
        >
          {message}
        </div>
      }
    />
  );
}

export const toastStatus = toastApi();
export const showToast = (error: any) =>
  toastStatus
    .getState()
    .setOpen(true, (error || 'An error occured.').toString());

type SuccessApi = {
  message: string;
};
export function successApi() {
  return create<SuccessApi>(() => ({
    message: null,
  }));
}

export const success = successApi();
export const showSuccessMessage = (message: string) =>
  success.setState({ message });

function SuccessComponent() {
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    return success.subscribe(
      (message) =>
        message &&
        enqueueSnackbar(message as any, {
          variant: 'success',
          onClose: () => success.setState({ message: null }),
        }),
      (s) => s.message
    );
  });
  return <div />;
}
export function SuccessContext() {
  return (
    <SnackbarProvider maxSnack={4}>
      <SuccessComponent />
    </SnackbarProvider>
  );
}
